'use strict';

/* General GUI Components */
import uiBootstrap from 'angular-ui-bootstrap';

import 'angular-xeditable';
import 'checklist-model/checklist-model';

import 'angular-timeline/dist/angular-timeline';
import 'angular-timeline/dist/angular-timeline.css';
import 'angular-timeline/dist/angular-timeline-bootstrap.css';

import 'ng-img-crop/compile/minified/ng-img-crop.js';
import 'ng-img-crop/compile/minified/ng-img-crop.css';

import 'chart.js/src/chart';
import 'angular-chart.js/angular-chart';

import 'angular-prompt/dist/angular-prompt';

import 'fullcalendar/dist/fullcalendar.min';
import 'fullcalendar/dist/fullcalendar.min.css';
import 'angular-ui-calendar/src/calendar';

import 'angular-ui-bootstrap-datetimepicker';
import 'angular-ui-bootstrap-datetimepicker/datetimepicker.css';

import ngDialogs from 'angular-dialog-service';
import ngFileUpload from 'ng-file-upload';

/* WYSIWYG & Code Editor */
import 'textangular/dist/textAngular-sanitize.min';
import 'textangular/dist/textAngular.min';
import 'textangular/dist/textAngular.css';

import 'angular-ui-codemirror/src/ui-codemirror';

/* Time Calculation Helpers */
import 'expose-loader?moment!moment-timezone';
import 'angular-moment';

/* Other imports */
import 'jquery-ui/ui/widgets/sortable';
import 'angular-ui-sortable/dist/sortable';

import ngValidationMatch from 'angular-validation-match';

/* Module */
export default angular.module('conduu.ap.imports', [

  /* General GUI Components */
  'xeditable', 'checklist-model', 'angular-timeline', 'ngImgCrop', 'cgPrompt', 'ui.calendar',
  'ui.bootstrap.datetimepicker', 'chart.js', ngDialogs, uiBootstrap, ngFileUpload,

  /* WYSIWYG & Code Editor */
  'textAngular', 'ui.codemirror',

  /* Time Calculation Helpers */
  'angularMoment',

  /* Others */
  'ui.sortable', ngValidationMatch
])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/imports/index.js